import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { useIconColorHex } from '@/app/common/icons/Icon';
import { starfishCssUrl } from '@/app/common/icons/starfish';
import { BaseBadgeContainer } from '../BaseBadge/styled';

const PHONE_ICON_SIZE = 17;

const BrandPrimaryBadge = styled(BaseBadgeContainer)`
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
`;

export const AppOnlyPriceBadge = () => {
  const { t } = useTranslation();
  const onDarkHex = useIconColorHex('iconOnDark');
  return (
    <BrandPrimaryBadge
      $icon={starfishCssUrl('UI Essentials', 'icon-phone', onDarkHex, PHONE_ICON_SIZE)}
      $iconSize={PHONE_ICON_SIZE}
      dangerouslySetInnerHTML={{ __html: t('vacation.oss.cards.app_only_price') }}
    />
  );
};

export const MobileOnlyPriceBadge = () => {
  const { t } = useTranslation();
  const onDarkHex = useIconColorHex('iconOnDark');
  return (
    <BrandPrimaryBadge
      $icon={starfishCssUrl('UI Essentials', 'icon-phone', onDarkHex, PHONE_ICON_SIZE)}
      $iconSize={PHONE_ICON_SIZE}
      dangerouslySetInnerHTML={{ __html: t('vacation.oss.cards.mobile_only_price') }}
    />
  );
};
